const escapeRegex = /`|"|'|&#39;|&quot;/g;

export const escapeCharacters = (str: string) => (str ? str.replace(escapeRegex, '') : str);

export const facebookShareUrl = (url: string) =>
  `https://facebook.com/sharer/sharer.php?u=${encodeURI(escapeCharacters(url))}`;

export const twitterShareUrl = (text: string, url: string) => {
  const escaped = escapeCharacters(text);
  return `https://twitter.com/intent/tweet?text=${encodeURI(escaped)}&url=${encodeURI(escapeCharacters(url))}`;
};

export const nextdoorShareLink = (url: string, text: string) => {
  const body = text ? `${text} ${url}` : url;
  return `https://nextdoor.com/sharekit?source=zencity&hashtag=zencity&body=${encodeURI(escapeCharacters(body))}`;
};

export const blueSkyShareUrl = (url: string) =>
  `https://bsky.app/intent/compose?text=${encodeURI(escapeCharacters(url))}`;

export const whatsappShareUrl = (url: string) => `https://wa.me/?text=${encodeURI(escapeCharacters(url))}`;

export const linkedinShareUrl = (url: string) =>
  `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(escapeCharacters(url))}`;

export const emailShareUrl = (subject: string, body: string) =>
  `mailto:?subject=${encodeURI(escapeCharacters(subject))}&body=${encodeURI(escapeCharacters(body))}`;
